
export const DEFAULTS = {
  FLUSH_INTERVAL: 10000, // 10 seconds
  MAX_BUFFER_SIZE: 1000,
  MAX_OFFLINE_BUFFER_SIZE: 500, // Max events to persist in localStorage when offline
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
  BATCH_SIZE: 10,
  SESSION_TIMEOUT: 1 * 60 * 60 * 1000, // 1 hours of inactivity
  SESSION_TOUCH_THROTTLE: 15 * 1000, // Min interval between lastSeenAt writes on activity
  RAGE_CLICK_THRESHOLD: 3, // Number of clicks to trigger rage detection
  RAGE_CLICK_WINDOW: 1000, // Time window in ms to detect rage clicks
  RAGE_EVENT_THRESHOLD: 4, // Number of events to trigger rage detection
  RAGE_EVENT_WINDOW: 2000,
  // Injected at build time by @rollup/plugin-replace from the .env file.
  // The __API_ENDPOINT__ token is replaced with the actual value during build.
  API_ENDPOINT:"https://stream.dhan.co", 
  LIBRARY: {
    name: "dhan-tracker-js",
    version: "1.4.0",
  },
  APP_INFO: {
    version: "1.0.0",
    build: "0001",
  },
};

export const ERROR_CODES = {
  INVALID_EVENT_TYPE: "INVALID_EVENT_TYPE",
  CONFIGURATION_ERROR: "CONFIGURATION_ERROR",
  NETWORK_ERROR: "NETWORK_ERROR",
};

export const PRIORITY = {
  HIGH: 1,
  NORMAL: 2,
  LOW: 3,
};



// Utility function to get IST time with milliseconds
export const getISTTime = () => {
  const date = new Date();
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).replace(/(\/)/g, '-').replace(', ', 'T') + '.' + date.getMilliseconds().toString().padStart(3, '0');
};

// Utility function to convert timestamp to IST with milliseconds
export const toISTTime = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).replace(/(\/)/g, '-').replace(', ', 'T') + '.' + date.getMilliseconds().toString().padStart(3, '0');
};
